<template>
  <div>
    <b-row class='mb-3'>
      <b-col cols="12">
        <label>Wydarzenia</label>
        <table class="table table-condensed">
          <thead>
            <tr>
              <th>Data</th>
              <th>Czas</th>
              <th>Nazwa</th>
              <th>Scena</th>
              <th>Wysłano</th>
            </tr>
          </thead>
          <tr v-for="(event, k) in events" :key="k">
            <td>{{event.date}}</td>
            <td>{{$moment(event.timeStart).format('HH:mm')}}</td>
            <td>{{event.eventName}}</td>
            <td>{{event.sceneName}}</td>
            <td>
              <b-form-checkbox
                class="ml-2 mr-sm-2 mb-sm-0"
                v-model='event.onesignalPushSent'
                @change='(e) => actions.handleEventPropChanged(event, "onesignalPushSent", e)'
              />
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { LOCALES, SOCIAL_MEDIA_WRAPPER_OPTIONS } from '@/const'
  import { handleSimplePropChanged, handleSimplePropWithLocaleChanged, handleNestedPropChanged, handleEventPropChanged } from '@/store/utils'
  
  export default {
    data() {
      return {
        locales: LOCALES,
        wrapper_options: SOCIAL_MEDIA_WRAPPER_OPTIONS,
        actions: {
          handleSimplePropChanged,
          handleSimplePropWithLocaleChanged,
          handleNestedPropChanged,
          handleEventPropChanged,
        },
      }
    },
    computed: {
      events() {
        try {
          return this.$store.state.fanzones.form.doc.events
        } catch {
          return []
        }
      },
      form() {
        return this.$store.state.fanzones.form
      }
    },
  }
</script>